import { Redirect } from 'react-router-dom';
import type { Request } from 'express';
import type { RouteItem } from 'utils/withSSR';
import Home from 'modules/Home';
import AboutUs from 'modules/AboutUs';
import Agreements from 'modules/Agreements';
import Page404 from 'modules/Page404';
import Disclaimers from 'modules/Disclaimers';
import Logout from 'modules/Logout';
import Brand from 'modules/Brand';
import Market from 'modules/Market';
import Email from 'modules/Email';
import Platform from 'modules/Platform';
import Dlapp from 'app/modules/Dlapp';
import Pricing from 'modules/Pricing';
import Help from 'modules/Help';
import HelpIndex from 'modules/Help/module/Index';
import HelpDetail from 'modules/Help/module/Detail';
import HelpSearch from 'modules/Help/module/Search';
import { UI } from 'stores/ui';
import URL from 'utils/URL';

export type { RouteItem };

// 需要进行跨站跳转的路由
export const redirectRoutes: Array<{ path: string; redirectUrl: (url: string, request: Request, ui: UI) => string }> = [
    {
        // plaid绑定回调中转
        // /transation/plaid/deposit|withdraw/[inapp]?token=xxxxx&oauth_state_id=xx   其中token为plaid返回内容，其他参数为约定的内容, inapp需要继续跳转到APP内操作, deposit/withdraw
        path: '/transaction/plaid',
        redirectUrl: (url, req, ui) => {
            const urlObj = URL.parse(url, true);
            const regResult = url.match(/\/transaction\/plaid\/([\w]+)\/?(inapp)?/);
            const source = regResult?.[1],
                inapp = Boolean(regResult?.[2]);

            const nextUrl = URL.merge(
                `https://${req.hostname}/personal/transfer/${
                    source === 'withdraw' ? 'withdraw' : 'deposit'
                }/plaid-continue`,
                {
                    query: urlObj.query
                }
            );

            if (inapp && !ui.isTiger) {
                return URL.merge('https://tradeup.com/activity/forapp/nativeapp?type=nbllq.h&iscallback=1', {
                    query: {
                        url: nextUrl,
                        fallback: nextUrl
                    }
                });
            }

            return nextUrl;
        }
    },
    {
        // 支持/download路径，与全球网站对齐
        path: '/download',
        redirectUrl: url => {
            return url.replace(/^\/download/, '/platform');
        }
    }
];

const routes: RouteItem[] = [
    {
        path: '/',
        exact: true,
        component: Home
    },
    {
        path: '/platform',
        exact: true,
        component: Platform
    },
    {
        path: '/download',
        exact: true,
        component: () => <Redirect from="/download" to="/platform" />
    },
    {
        path: '/dlapp',
        exact: true,
        component: Dlapp
    },
    {
        path: '/aboutus',
        component: AboutUs
    },
    {
        // 优先使用这个
        path: '/about',
        component: AboutUs
    },
    {
        // 客户端跳转
        path: '/tradeup/about',
        component: AboutUs
    },
    {
        path: '/agreement/:id',
        component: Agreements
    },
    {
        path: '/statement/:id',
        component: Agreements
    },
    {
        path: '/help',
        component: Help,
        routes: [
            {
                path: '/help/search',
                render: props => {
                    if (props.location.search.includes('keyword')) {
                        return <HelpSearch {...props} />;
                    }

                    return <Redirect to={'/help'} />;
                }
            },
            {
                path: '/help/:main/:sub?',
                component: HelpDetail
            },
            {
                path: '/help',
                component: HelpIndex
            }
        ]
    },
    {
        path: '/pricing',
        component: Pricing
    },
    {
        path: '/disclaimers',
        component: Disclaimers
    },
    {
        path: '/logout',
        component: Logout
    },
    {
        path: '/regb',
        component: Brand
    },
    {
        path: '/market',
        component: Market
    },
    {
        path: '/email',
        component: Email
    },
    {
        component: Page404
    }
];

export default routes;
